import Alert from "@mui/material/Alert";
import { useForm } from "react-hook-form";
import useFormField from "../hooks/useFormField";
import Button from "@mui/material/Button";
import TextInput from "../ui/TextInput";
import React from "react";
import { validateArtistName } from "../api/artistReview";
import { describeApiError } from "../api/request";
export default function ArtistNameEditor({
  artist,
  pending,
  disabled,
  error,
  onSave,
  onCancel,
}) {
  const form = useForm({
    defaultValues: {
      draft: artist.name,
    },
    mode: "onChange",
  });
  const [draft, setDraft] = useFormField(form, "draft", {
    validate: (value) => validateArtistName(value) || true,
  });
  const validation = validateArtistName(draft);
  const inputId = `artist-name-${artist.id}`;
  return (
    <form
      className="artist-name-editor"
      onSubmit={form.handleSubmit(async () => {
        if (!validation && !pending && !disabled && draft !== artist.name) {
          if (await onSave(draft)) onCancel();
        }
      })}
      onKeyDown={(event) => {
        if (event.key === "Escape" && !pending) {
          event.preventDefault();
          onCancel();
        }
      }}
    >
      <label htmlFor={inputId}>Primary artist name</label>
      <TextInput
        id={inputId}
        autoFocus
        value={draft}
        disabled={pending}
        aria-invalid={!!validation}
        aria-describedby={`${inputId}-help`}
        onChange={(event) => setDraft(event.target.value)}
      />
      <p id={`${inputId}-help`}>
        {validation ||
          "Changes the shared local name for all users; Discogs is unchanged."}
      </p>
      {error && (
        <Alert role="alert" severity="error">
          {describeApiError(error)}
        </Alert>
      )}
      <div className="review-actions">
        <Button
          className="btn"
          type="submit"
          disabled={
            disabled || pending || !!validation || draft === artist.name
          }
        >
          {pending ? "Saving…" : "Save"}
        </Button>
        <Button
          className="btn"
          type="button"
          disabled={pending}
          onClick={onCancel}
        >
          Cancel
        </Button>
      </div>
    </form>
  );
}
